import { capitaliseFirstWord } from '@monash/portal-frontend-common';
import { LINKS_FILTER_OPTIONS } from '../../link-form/filters/constants';
import { LINK_STATUS } from '../constants';
import { getNullSubcatsId } from './by-category';

// Utils to get the options for filtering the visible links on the Admin Links dashboards

export const getCategoryFilterOptions = (categories) => {
  if (!categories) return [];

  return categories.map((category) => {
    const { title, id, subcategories } = category;

    const option = { text: title, value: id };

    if (subcategories?.length) {
      const subcatsWithNull = [
        ...subcategories,
        { title: 'No subcategory', id: getNullSubcatsId(id) }, // This option shows links that belong to this cateogory, but no subcategories within that category
      ];

      option.subOptions = subcatsWithNull.map((subcat) => {
        return { text: subcat.title, value: subcat.id };
      });
    }

    return option;
  });
};

export const NULL_COHORTS_ID = 'NULL_COHORT'; // Use this const to identify the "No location and cohort" filter option
export const NULL_COHORTS_TEXT = 'No Location and Cohort';

export const getCohortFilterOptions = () => {
  const optionsByLocation = Object.values(LINKS_FILTER_OPTIONS).map(
    (location) => {
      const { prefix, value, subFilters } = location;

      const subOptions = subFilters
        ? Object.values(subFilters).map((cohort) => {
            const { text, value } = cohort;
            return { text, value };
          })
        : [];

      const options = [
        {
          text: prefix,
          value,
        },
        ...subOptions,
      ];

      return {
        text: location.prefix,
        options,
      };
    }
  );

  return [
    ...optionsByLocation,
    {
      text: NULL_COHORTS_TEXT,
      options: [
        {
          text: capitaliseFirstWord(NULL_COHORTS_TEXT),
          value: NULL_COHORTS_ID,
        },
      ],
    },
  ];
};

export const getStatusFilterOptions = () => {
  const { ARCHIVED, ...relevantStatuses } = LINK_STATUS;
  return Object.values(relevantStatuses).map((status) => {
    return { text: capitaliseFirstWord(status), value: status };
  });
};
